// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay--W8A","content":"Overlay_content--HqI"};